import { TRPCClientError } from '@trpc/client';

/** The server refused because the row is in a locked (reconciled / verified) period. */
export const lockedPeriod = (e: unknown): { lockedThrough: string } | null => {
  const d = e instanceof TRPCClientError ? (e.data as { details?: { code?: unknown; lockedThrough?: unknown } } | undefined)?.details : undefined;
  return d?.code === 'PERIOD_LOCKED' && typeof d.lockedThrough === 'string' ? { lockedThrough: d.lockedThrough } : null;
};

/**
 * Run a transaction edit/delete; if it hits a locked period, ask (native confirm dialog) and retry with `confirmLocked`.
 * Declining rethrows the original error, so callers' error handling shows why nothing changed.
 */
export const withLockConfirm = async <T>(run: (flag: { confirmLocked?: true }) => Promise<T>): Promise<T> => {
  try {
    return await run({});
  } catch (e) {
    const locked = lockedPeriod(e);
    if (!locked || !window.confirm(`This transaction is in a locked period (balance confirmed to ${locked.lockedThrough}). Changing it means that balance may no longer match. Change it anyway?`)) throw e;
    return run({ confirmLocked: true });
  }
};
